import { render, staticRenderFns } from "./FormControlTypeMonth.vue?vue&type=template&id=3387a07c&scoped=true"
import script from "./FormControlTypeMonth.vue?vue&type=script&lang=js"
export * from "./FormControlTypeMonth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3387a07c",
  null
  
)

export default component.exports